module.exports = __webpack_public_path__ + "static/media/arrow_right_gray_nospace.6267bfbc.svg";